var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-link btn-sm btn-circle window-vue-button-information ml-2 mt-2",on:{"click":function($event){return _vm.informationOrder()}}},[_c('i',{staticClass:"fas fa-info-circle text-info"}),_vm._v(" Información ")])
}
var staticRenderFns = []

export { render, staticRenderFns }